/* Dawn cross-sell / upsell — Regios DOPP discount integration */
(function () {
  'use strict';

  if (window.DDCartCrossSell) return;

  function formatMoney(cents) {
    var val = parseInt(cents, 10) / 100;
    // Match Liquid `money_without_trailing_zeros`: whole-dollar amounts
    // render as "$180", non-zero decimals as "$180.50".
    var fixed = val.toFixed(2);
    if (fixed.slice(-3) === '.00') fixed = fixed.slice(0, -3);
    return '$' + fixed;
  }

  function applyRegiosToCard(card) {
    var v0 = window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0;
    if (!v0) return;

    var productId = parseInt(card.getAttribute('data-product-id') || '0', 10);
    var variantId = parseInt(card.getAttribute('data-variant-id') || '0', 10);
    var priceCents = parseInt(card.getAttribute('data-variant-price') || '0', 10);
    if (!productId || !variantId || !priceCents) return;

    var priceEl = card.querySelector('[data-dd-upsell-price], [data-dd-xsell-price]');
    if (!priceEl) return;

    var promise;
    if (v0.productPage && typeof v0.productPage.calculateDiscountedPrices === 'function') {
      promise = v0.productPage.calculateDiscountedPrices.call(v0.productPage, {
        variantId: variantId,
        quantity: 1
      });
    } else if (typeof v0.calculateDiscountedPrices === 'function') {
      promise = v0.calculateDiscountedPrices.call(v0, {
        productId: productId,
        variantId: variantId,
        regularPriceInCents: priceCents
      });
    } else {
      return;
    }

    promise
      .then(function (result) {
        if (!result || !result.salePrice || !result.regularPrice) return;
        if (result.salePrice.amount >= result.regularPrice.amount) return;

        var saleCents = Math.round(parseFloat(result.salePrice.amount) * 100);
        var regCents = Math.round(parseFloat(result.regularPrice.amount) * 100);

        priceEl.textContent = formatMoney(saleCents);
        priceEl.classList.add(
          priceEl.hasAttribute('data-dd-upsell-price')
            ? 'dd-upsell__price--sale'
            : 'dd-cross-sell__price--sale'
        );

        var compareEl = card.querySelector('[data-dd-upsell-compare], [data-dd-xsell-compare]');
        if (compareEl) {
          compareEl.textContent = formatMoney(regCents);
          compareEl.style.display = '';
        }
      })
      .catch(function () { /* silent — Liquid compare_at fallback already shown */ });
  }

  function processAllCards() {
    var cards = document.querySelectorAll(
      '[data-dd-upsell-card][data-variant-price], [data-dd-cross-sell-item][data-variant-price]'
    );
    for (var i = 0; i < cards.length; i++) {
      applyRegiosToCard(cards[i]);
    }
  }

  function init() {
    processAllCards();
  }

  function pollRegios() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var v0 = window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0;
      var hasApi = v0 && (v0.productPage || v0.calculateDiscountedPrices);
      if (hasApi) {
        clearInterval(timer);
        processAllCards();
      } else if (attempts >= 20) {
        clearInterval(timer);
      }
    }, 500);
  }

  function bindCartSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(processAllCards, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pollRegios();
      bindCartSync();
    });
  } else {
    pollRegios();
    bindCartSync();
  }

  window.DDCartCrossSell = { init: init };
})();
